/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_R3_AddressInputs */

const tr_kvkkbasvuru_s2_r3_address = /** @type {(inputs: Kvkkbasvuru_S2_R3_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pınarbaşı Mah. 740 Sk. Ülker Apt. No:3/10, Konyaaltı/Antalya`)
};

const en_kvkkbasvuru_s2_r3_address = /** @type {(inputs: Kvkkbasvuru_S2_R3_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pınarbaşı Mah. 740 Sk. Ülker Apt. No:3/10, Konyaaltı/Antalya`)
};

const de_kvkkbasvuru_s2_r3_address = /** @type {(inputs: Kvkkbasvuru_S2_R3_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pınarbaşı Mah. 740 Sk. Ülker Apt. No:3/10, Konyaaltı/Antalya`)
};

const ru_kvkkbasvuru_s2_r3_address = /** @type {(inputs: Kvkkbasvuru_S2_R3_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pınarbaşı Mah. 740 Sk. Ülker Apt. No:3/10, Konyaaltı/Antalya`)
};

/**
* | output |
* | --- |
* | "Pınarbaşı Mah. 740 Sk. Ülker Apt. No:3/10, Konyaaltı/Antalya" |
*
* @param {Kvkkbasvuru_S2_R3_AddressInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_r3_address = /** @type {((inputs?: Kvkkbasvuru_S2_R3_AddressInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_R3_AddressInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_r3_address(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_r3_address(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_r3_address(inputs)
	return tr_kvkkbasvuru_s2_r3_address(inputs)
});